import React from "react"

import {
  YARDS_TO_MILES_THRESHOLD,
  METERS_TO_KM_THRESHOLD
} from "@irati/geolocation/src/constants/proximity"
import {FormattedMessage} from "@irati/utils/lang"
import {
  metersToMiles,
  metersToYards,
  metersToKm
} from "@irati/geolocation/src/helpers/geometry"
import authentication from "@irati/auth"
import locale from "@irati/utils/locale"

export const convertProximity = (proximityMeters) => {
  const userDistanceUnits = authentication.userUnits().distance

  if (userDistanceUnits === locale.units.miles) {
    const proximityYards = metersToYards(proximityMeters).toFixed(2)
    if (proximityYards < YARDS_TO_MILES_THRESHOLD) {
      return <FormattedMessage id="geolocation.services.proximity.yards" values={{proximity: proximityYards}} />
    }
    const proximityMiles = metersToMiles(proximityMeters).toFixed(2)
    return <FormattedMessage id="geolocation.services.proximity.miles" values={{proximity: proximityMiles}} />
  } else if (userDistanceUnits === locale.units.km) {
    if (proximityMeters < METERS_TO_KM_THRESHOLD) {
      return <FormattedMessage id="geolocation.services.proximity.meters" values={{proximity: proximityMeters}} />
    }
    const proximityKm = metersToKm(proximityMeters).toFixed(2)
    return <FormattedMessage id="geolocation.services.proximity.km" values={{proximity: proximityKm}} />
  }
  return null
}
